// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2xgr6","content":"ManualTimeModal_content___LGYP"};